import React, { useEffect, useRef, useState } from 'react';
import {
    Card,
    Col, Form, FormSelect, DatePicker,
    ListGroup,
    ListGroupItem,
    Row,
    Container,
    Button,
    FormInput,
} from "shards-react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import InputBox from '../../common/InputBox';
import { useLocation } from 'react-router-dom';
import { setAlert } from "../../../redux/actions/alert";
import {
    clear_user_profile,
    get_client_list,
    get_compensation_types,
    get_country_list,
    sub_get_currency_list,
    get_deal_types_types,
    get_region_list,
    get_subscriber_list,
    get_hr_Consultant,
    get_user_profile,
    get_worker_types, reset,
    get_pay_component_list,
    save_user_profile,
    update_isSave_user_profile,
    get_pay_item_list,
    sync_pay_items,
    attach_Pay_Item,
    get_client_information
} from "../../../redux/actions/user";
import { calculateEndDate, plusDays, setAPIDate, setDateForTable, setInputDate } from '../../../utils/date';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { compareObjects, fixedDecimalPlaces, parsingUserProfileSavingObject } from '../../../utils/general';
import StandardFormInput from '../../common/StandardFormInput';
import { STANDARD_FORMATS, SUBSCRIBER_SYNC_TYPE } from '../../../utils/constants';
import PayTypeComponentModal from '../PayTypeComponentModal';
import ConfirmAlert from '../../common/ConfirmAlert';
import CRBadge from '../../common/CRBadge';

function HSAForm(props) {
    const location = useLocation();
    const changeRequestedFields = (location.state && location.state.changeRequestedFields) || {};
    const currentRecordId = location.state?.row?.HSAId;
    const crKeyPrefix = `hsainfos[${currentRecordId}].`;
    const recordCRFields = currentRecordId != null
      ? Object.fromEntries(
          Object.entries(changeRequestedFields)
            .filter(([k]) => k.startsWith(crKeyPrefix))
            .map(([k, v]) => [`hsainfos.${k.slice(crKeyPrefix.length)}`, v])
        )
      : {};
    const [notesCharacters, seNotesCharacters] = useState(100);
    const history = useHistory();
    const [hasError, setHasError] = useState(false);
    const formDataVal = useRef({})
    const [disabledSave, setDisabledSave] = useState(location.state ? location.state.row !== undefined : false)
    
    const [disabledEndDate, setDisableEndDate] = useState(location.state.row !== undefined && location.state.formData.HSAInfos[0] !== undefined && location.state.row.HSAId !== location.state.formData.HSAInfos[0].HSAId );

    const onChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    const onChangeStandardInput = (name,value) => {
        setFormData({...formData, [name]: value});
    };

    const isSubmitted = useRef(true);
    const [confirmAlert, setConfirmAlert] = useState({
        confirmMsg: "",
        visible: false,
        onConfirm: null,
    });

    const onMonetaryAmountChanged = (e, decimalPlaces) => {

        const value = e.target.value;

        const sanitizedValue = value.replace(/[^0-9.]/g, '');

        const parts = sanitizedValue.split('.');

        if (parts.length > 1 && parts[1].length > 2) {
            parts[1] = parts[1].slice(0, decimalPlaces);
        }

        const formattedValue = parts.join('.');

        e.target.value = formattedValue;

        onChange(e);
    };

    const SavingDataInObject = () => {
        let updatedFormData = { ...formData };
        if ('HSAStartDate' in updatedFormData) updatedFormData.HSAStartDate = setInputDate(updatedFormData.HSAStartDate);
        if ('HSAEndDate' in updatedFormData) updatedFormData.HSAEndDate =  updatedFormData.HSAEndDate === '' ? '0' : setInputDate(updatedFormData.HSAEndDate);
        if ('HSAAmount' in updatedFormData) updatedFormData.HSAAmount = fixedDecimalPlaces(updatedFormData.HSAAmount, 2);
        if ('HSAMarkupAmount' in updatedFormData) updatedFormData.HSAMarkupAmount = fixedDecimalPlaces(updatedFormData.HSAMarkupAmount, 2);

        formDataVal.current = {...updatedFormData}
        let isSaved = false;

        if (location.state && location.state.formData) {

            for (const HSAInfo of location.state.formData.HSAInfos) {
                let currentDate = new Date(setDateForTable(HSAInfo.HSAStartDate)).setHours(0, 0, 0, 0);
                let selectedDate = new Date(formData.HSAStartDate).setHours(0, 0, 0, 0);
                if (HSAInfo.HSAId !== formData.HSAId &&  selectedDate === currentDate) {
                    props.setAlert("Details with the same Worker HSA Start Date exists.", "danger");
                    return 0;
                }
            }
        }
        if (location.state.row) {

            let currentHSAInfos = location.state.formData.HSAInfos;
            let updatedHSAs = [];
            if (currentHSAInfos) {
                updatedHSAs = currentHSAInfos.map(hsa => {
                    if (hsa.HSAId === updatedFormData.HSAId) {
                        return {
                            userId: updatedFormData.userId,
                            HSAAmount: updatedFormData.HSAAmount,
                            HSACarryOver: updatedFormData.HSACarryOver,
                            HSAProvider: updatedFormData.HSAProvider,
                            HSAWaitingPeriod: updatedFormData.HSAWaitingPeriod,
                            HSAWaitingPeriodUnit: updatedFormData.HSAWaitingPeriodUnit,
                            frequency: updatedFormData.frequency,
                            HSAApplicable: updatedFormData.HSAApplicable,
                            HSAStartDate: updatedFormData.HSAStartDate,
                            HSAEndDate: updatedFormData.HSAEndDate === "" ? "0" : updatedFormData.HSAEndDate,
                            HSAContributionCurrency: updatedFormData.HSAContributionCurrency,
                            HSAPayComponentId: updatedFormData.HSAPayComponentId,
                            HSAMarkup: updatedFormData.HSAMarkup,
                            HSAMarkupAmount: updatedFormData.HSAMarkupAmount,
                            notes: updatedFormData.notes,
                            HSAId: updatedFormData.HSAId,
                            //Added by nipul
                            syncPayItem: updatedFormData.syncPayItem,
                            payItemRefNum: updatedFormData.payItemRefNum
                        };
                    }
                    else {
                        return hsa;
                    }
                })
            }

            location.state.formData.HSAInfos = updatedHSAs;
            isSaved = true;
        } else {
            location.state.formData = { ...location.state.formData, HSAInfos: [{ ...updatedFormData }, ...location.state.formData.HSAInfos],HSAApplicable: 'Yes'}
            isSaved = true
        }

        if(isSaved) {
            if(location.state.formData.HSAInfos.length > 1){
                location.state.formData.HSAInfos.sort(function(eap1, eap2){return eap2.HSAStartDate - eap1.HSAStartDate});
                for(let i = 0; i < location.state.formData.HSAInfos.length; i++){
                   if(location.state.formData.HSAInfos[i].HSAEndDate !== '0'){
                        if((i+1) < location.state.formData.HSAInfos.length ){
                            
                            location.state.formData.HSAInfos[i+1].HSAEndDate = calculateEndDate(location.state.formData.HSAInfos[i].HSAStartDate, 1);
                        }
                   }
                   else{
                        if(i === 0 && (i+1) < location.state.formData.HSAInfos.length && location.state.formData.HSAInfos[i+1].HSAEndDate !== '0') continue;
                        location.state.formData.HSAInfos[i+1].HSAEndDate = location.state.formData.HSAInfos[i] ? calculateEndDate(location.state.formData.HSAInfos[i].HSAStartDate, 1) : '0';
                   }  
                }
            }
        }
        
        return isSaved;
    }

    const onSave = async (e) => {

        e.preventDefault();
        if (SavingDataInObject()) {
            let userId = formData.userId === undefined ? 0 : formData.userId;
            let roleStr = (formData.userId !== undefined && location.state.role !== undefined) ? `?role=${location.state.role}` : '?role=';
            history.push({
                pathname: `/manage-user-profile/${userId}`,
                search: `${roleStr}&section=benefits&subSection=perks`,
                state: { formData, formData: location.state.formData, formDataRef: location.state.formDataRef, sectionformDataRef: location.state.sectionformDataRef, reload: props.isSaveUserProfile, changeRequestedFields: location.state.changeRequestedFields || {}, userProfile: location.state.userProfile },
            });

        }
    }

    const onCancel = ()=>{
        let userId = formData.userId === undefined ? 0 : formData.userId;
        let roleStr = (formData.userId !== undefined && location.state.role !== undefined) ? `?role=${location.state.role}` : '?role=';
        props.update_isSave_user_profile(false);
        history.push({
            pathname: `/manage-user-profile/${userId}`,
            search: `${roleStr}&section=benefits&subSection=perks`,
            state: { formData, formData: location.state.formData, formDataRef: location.state.formDataRef, sectionformDataRef: location.state.sectionformDataRef, reload: props.isSaveUserProfile, changeRequestedFields: location.state.changeRequestedFields || {}, userProfile: location.state.userProfile },
        });
    }
    const onDateChange = (name, value) => {

        let HSAInfos = location.state.formData.HSAInfos;

        let hireDate = new Date(location.state.formData.hireDate).setHours(0, 0, 0, 0);
       let selectedDate = new Date(value).setHours(0, 0, 0, 0);

       let checkBackDate = false;
        let HSAStartDate = new Date(name === 'HSAEndDate' ? formData.HSAStartDate : value ).setHours(0, 0, 0, 0);
        let HSAEndDate = new Date(name === 'HSAStartDate' ? formData.HSAEndDate : value).setHours(0, 0, 0, 0);
        //let selectedDate = new Date(formData.benefitsStartDate).setHours(0, 0, 0, 0);    
        let currentDate = new Date().setHours(0, 0, 0, 0);    
        let selectedPreviousEndDate = '';

       if(name === 'HSAEndDate'){
        if(selectedDate > 0  && selectedDate < HSAStartDate){
            props.setAlert("HSA End Date must not be less than HSA Start Date.", "danger");
            return;
        }

        setFormData({ ...formData, [name]: value});
        return;

    }else
      { 
        if(selectedDate < hireDate){
           props.setAlert("Effective Date must not be less than the Hire Date.", "danger");
           return 0;
       }

       if(formData.HSAEndDate !== '' && HSAStartDate > HSAEndDate){
        props.setAlert("HSA Start Date must be greater than HSA End Date.", "danger");
        return;
        }
        checkBackDate = selectedDate < currentDate

        for (let i = 0; i < HSAInfos.length ; i++ ) {
            let currentHSA = HSAInfos[i];
            //let previousHSA = HSAInfos[i+1];

            let currentDate = new Date(setDateForTable(currentHSA[name])).setHours(0, 0, 0, 0);
           
            let prevEndDate = (currentHSA && currentHSA.HSAEndDate !== '0') ? new Date(setDateForTable(currentHSA.HSAEndDate)).setHours(0, 0, 0, 0) : '';
            let prevStartDate = (currentHSA && currentHSA.HSAStartDate !== '0') ? new Date(setDateForTable(currentHSA.HSAStartDate)).setHours(0, 0, 0, 0) : '';
            if(selectedDate < prevEndDate &&  selectedDate > prevStartDate && currentHSA){
                selectedPreviousEndDate = setAPIDate(currentHSA.HSAEndDate);
                checkBackDate = true;
               
            }

            if(prevEndDate !== ''  && selectedDate === prevEndDate){
                props.setAlert("HSA can not start from previous HSA End Date.", "danger");
                return 0;
            }

            if (currentHSA.HSAId !== formData.HSAId && selectedDate === currentDate) {
                props.setAlert("Details with the same Worker HSA Start Date exists", "danger");
                return 0;
            }
        }
        setDisableEndDate(checkBackDate)

    }
       // setHasError(!hasError)
        setFormData({ ...formData, [name]: value, HSAEndDate : checkBackDate ? selectedPreviousEndDate : formData.HSAEndDate });

    };


    const [formData, setFormData] = useState({

        userId: location.state.formData.userId,
        HSAAmount: '',
        HSACarryOver: '',
        HSAProvider: '',
        HSAWaitingPeriod: '',
        HSAWaitingPeriodUnit: '',
        frequency: '',
        HSAApplicable: '',
        HSAStartDate: location.state.formData.HSAInfos.length > 0 ? new Date() : location.state.formData.hireDate,//location.state.userProfile.userId === undefined ? location.state.formData.hireDate : new Date(),
        HSAEndDate: '',
        HSAContributionCurrency: location.state.formData.baseCurrency,
        HSAPayComponentId: '0',
        HSAMarkup: location.state.clientMarkups && location.state.clientMarkups.HSAType,
        HSAMarkupAmount: location.state.clientMarkups && fixedDecimalPlaces(location.state.clientMarkups.HSAAmount, 2),
        notes: '',
        HSAId: 1,
        ciCompensationCurrency: '',

        //Added by nipul
        syncPayItem: location.state.formData.syncPayItem,
        payItemRefNum: location.state.formData.payItemRefNum,

    });

    var payComponentListOption = props.payComponentList && props.payComponentList.filter(x => x.type === "Recurring").map((cmp) => {
        return <option key={cmp.name + cmp.refNum} value={cmp.refNum}>{cmp.name}</option>;
    });

    var currencyListOptions = props.currencyList && props.currencyList.map((option) => {
        return <option key={option.currencyCode + option.currencyId}
            value={option.currencyCode}>{option.currencySymbol + ' ' + option.currencyCode}</option>;
    });

    const monthsList = [];
    for (var i = 0; i <= 12; i++) {
        monthsList.push(<option key={i} value={i}>{i}</option>)
    }

    useEffect(() => {


        if (location.state.userProfile.firstName) {
            props.changePageMeta(`Health Spending Account - ${location.state.userProfile.personalInfo.firstName} ${location.state.userProfile.personalInfo.lastName}`, location.state.row === undefined ? `ADD` : `EDIT`)
        }
        else {
            props.changePageMeta(`Health Spending Account - ${location.state.formData.firstName} ${location.state.formData.lastName}`, location.state.row === undefined ? `ADD` : `EDIT`)

        }

        props.sub_get_currency_list();
        props.get_pay_component_list();

        if (location.state.formData.clientId && !location.state.row) {
            props.get_client_information(location.state.formData.clientId);
        }

        if (location.state && location.state.row) {

            let currentHSA = { ...location.state.row }

            setFormData({
                ...formData,
                userId: currentHSA.userId,
                HSAAmount: currentHSA.HSAAmount,
                HSACarryOver: currentHSA.HSACarryOver,
                HSAProvider: currentHSA.HSAProvider,
                HSAWaitingPeriod: currentHSA.HSAWaitingPeriod,
                HSAWaitingPeriodUnit: currentHSA.HSAWaitingPeriodUnit,
                frequency: currentHSA.frequency,
                HSAApplicable: currentHSA.HSAApplicable,
                HSAStartDate: setAPIDate(currentHSA.HSAStartDate),
                HSAEndDate: setAPIDate(currentHSA.HSAEndDate),
                HSAContributionCurrency: currentHSA.HSAContributionCurrency,
                HSAPayComponentId: currentHSA.HSAPayComponentId,
                HSAMarkup: currentHSA.HSAMarkup,
                HSAMarkupAmount: currentHSA.HSAMarkupAmount,
                notes: currentHSA.notes,
                HSAId: currentHSA.HSAId,

                //Added by nipul
                syncPayItem: Number(currentHSA.syncPayItem) || 0,
                payItemRefNum: currentHSA.payItemRefNum,
            })
        }else{
            if(location.state.formData.HSAInfos[0]){
                //setFormData({...formData, HSAId : Number(location.state.formData.HSAInfos[0].HSAId) + 1})

                let HSAIds = location.state.formData.HSAInfos.map(hsa => Number(hsa.HSAId));
                setFormData({...formData,
                     HSAId: Math.max(...HSAIds) + 1,
                     HSAAmount: location.state.formData.HSAInfos[0].HSAAmount,
                     HSACarryOver: location.state.formData.HSAInfos[0].HSACarryOver,
                     HSAProvider: location.state.formData.HSAInfos[0].HSAProvider,
                     HSAWaitingPeriod: location.state.formData.HSAInfos[0].HSAWaitingPeriod,
                     HSAWaitingPeriodUnit: location.state.formData.HSAInfos[0].HSAWaitingPeriodUnit,
                     frequency: location.state.formData.HSAInfos[0].frequency,
                     HSAApplicable: location.state.formData.HSAInfos[0].HSAApplicable,
                     HSAContributionCurrency: location.state.formData.HSAInfos[0].HSAContributionCurrency,
                     HSAPayComponentId: location.state.formData.HSAInfos[0].HSAPayComponentId,
                     HSAMarkup: location.state.formData.HSAInfos[0].HSAMarkup,
                     HSAMarkupAmount: location.state.formData.HSAInfos[0].HSAMarkupAmount,
                     HSAStartDate: location.state.formData.HSAInfos[0].HSAEndDate !== '0' ? setAPIDate(plusDays(location.state.formData.HSAInfos[0].HSAEndDate, 1)) : formData.HSAStartDate,
                     notes: location.state.formData.HSAInfos[0].notes,
                     //Added by nipul
                     syncPayItem: 0,
                     payItemRefNum: 0,
                })
            }
        }

    }, [])

    useEffect(()=>{
        if(location.state.row){     
            setDisabledSave(compareObjects(location.state.row, formData))
        }
    },[formData])

    useEffect(() => {
        if (!location.state.row && props.clientInformation?.defaultInvoiceFrequencyName) {
            setFormData((prev) => ({
                ...prev,
                frequency: props.clientInformation.defaultInvoiceFrequencyName,
            }));
        }
    }, [props.clientInformation])

    // --> Need to check and rectify below code
    
    let roleSelected = location.state.formData.workerFlag
        || location.state.formData.clientUserFlag
        || location.state.formData.subscriberUserFlag
        || location.state.formData.subscriberApiIntegrationFlag
        || location.state.formData.clientHRFlag
        || location.state.formData.subscriberHRFlag
        || location.state.formData.clientBillingFlag
        || location.state.formData.subscriberBillingFlag
        || location.state.formData.clientAdminFlag
        || location.state.formData.subscriberAdminFlag
        || location.state.formData.systemAdminFlag
    
    //Added by nipul for modal pop-up
    const [userNameForModal, setUserNameForModal] = useState('');
    const [openModalForPayItem, setOpenModalForPayItem] = useState(false);
    const [selected, setSelected] = useState(formData.payItemRefNum);
    const [isSelectable, setIsSelectable] = useState(false);

    const toggleModal = () => {
        setOpenModalForPayItem(!openModalForPayItem);
    }

    const removingObject = (refNum)=>{
        location.state.formData.HSAInfos = (location.state.formData.HSAInfos || []).filter(hsa=> hsa.HSAId !== refNum)
    }

    const syncPayItemWithUser = async () => {
        const currentHSAInfo = location.state.sectionformDataRef && (location.state.sectionformDataRef.HSAInfos || []).find(hsa => hsa.HSAId === formData.HSAId);
        const identical =  currentHSAInfo ? compareObjects(currentHSAInfo, formData) : false;
        if (!identical) {
            setConfirmAlert({
                ...confirmAlert,
                confirmMsg: 'HSA is not saved. Would you like to save it now?',
                visible: true,
                onConfirm: async () => {
                    setConfirmAlert({
                        ...props.confirmAlert,
                        visible: false
                    })
                    if (!checkCurrentForm()) {
                        isSubmitted.current = false;
                        document.getElementById('btnSave').click();
                    }
                    else {
                        isSubmitted.current = true;
                        if (SavingDataInObject()) {
                            let profileSaved = await parseModuleObjectForSave();
                            if (profileSaved) {
                                location.state.row = {...formData}
                                let res = await props.sync_pay_items(formData.userId, SUBSCRIBER_SYNC_TYPE.HSA, formData.HSAId);
                                if (res) {
                                    setFormData({ ...formData, ["syncPayItem"]: 1, payItemRefNum:res});
                                    changeLocationStateFormValues("syncPayItem", 1);
                                    changeLocationStateFormValues("payItemRefNum", res);
                                }
                            }
                            else{
                                removingObject(formData.HSAId)
                            }
                        }
                    }
                }
            })
        }
        else {
            //Call an API here for syncing after selection
            let res = await props.sync_pay_items(formData.userId, SUBSCRIBER_SYNC_TYPE.HSA, formData.HSAId);
            if (res) {
                setFormData({ ...formData, ["syncPayItem"]: 1, payItemRefNum:res});
                changeLocationStateFormValues("syncPayItem", 1);
                changeLocationStateFormValues("payItemRefNum", res);
                // location.state.row.syncPayItem = 1;
            }
        }
        
    }

    async function parseModuleObjectForSave() {
        let savingObject = parsingUserProfileSavingObject(location.state.formData, location.state.sectionformDataRef, location.state.formDataRef, roleSelected);
        if (savingObject !== undefined && savingObject.flag) {
            let response = await props.save_user_profile(savingObject.finalData);
            return response;
        }
        else {
            props.setAlert(savingObject.errorMessage, "danger");
            return savingObject.flag;
        }
    }
    
    function changeLocationStateFormValues(property, value) {
        let updatedFormData = { ...formData };
        let currentArray = location.state.formData.HSAInfos;
        let updatedArray = [];
        if (currentArray) {
            updatedArray = currentArray.map(item => {
                if (item.HSAId === updatedFormData.HSAId) {
                    return { ...item, [property]: value }
                }
                else {
                    return item;
                }
            })
        }
        location.state.formData.HSAInfos = updatedArray;
        location.state.formDataRef.HSAInfos = updatedArray;
        location.state.sectionformDataRef.HSAInfos = updatedArray;
    }

    function checkCurrentForm() {
        let isValid = true;
        let propArray = ['HSAProvider', 'HSAStartDate', 'HSACarryOver'
            , 'frequency', 'HSAContributionCurrency', 'HSAWaitingPeriod'
            , 'HSAWaitingPeriodUnit', 'HSAAmount', 'HSAMarkup', 'HSAMarkupAmount']
        
        let currentItems = {...formData};
        propArray.map(item => {
            if(currentItems.hasOwnProperty(item)){
                if(currentItems[item] === '')
                    isValid = false;
            }
        })
        
        return isValid;
    }

    const openPayItemReference = async (editable) => {
        // let isItemExists = location.state.formData.compensationInfos.filter((x) => { return (x.cicompensationId === formData.cicompensationId)});
        if(Number(location.state.formData.userId) !== 0) await props.get_pay_item_list(location.state.formData.userId)
        const currentHSAInfo = location.state.sectionformDataRef && (location.state.sectionformDataRef.HSAInfos || []).find(HSA => HSA.HSAId === formData.HSAId);
        const identical = currentHSAInfo ? compareObjects(currentHSAInfo, formData) : false;
        if (!identical) {
            // Need to make an API call of save or update and if there are error then show the error, if all good then open the pop-up
            // So do entire saving process from each tab and make a common function to do it
            // No validation required to do as per ankit -> Add blank user and add module(retainer, placement, benefit, compensation & retirement)
            // Need to open pop up first and then based on confirmation we need to
            setConfirmAlert({
                ...confirmAlert,
                confirmMsg: 'Compensation is not saved. Would you like to save it now?',
                visible: true,
                onConfirm: async () => {
                    setConfirmAlert({
                        ...props.confirmAlert,
                        visible: false
                    })
                    if (!checkCurrentForm()) {
                        isSubmitted.current = false;
                        document.getElementById('btnSave').click();
                    }
                    else {
                        isSubmitted.current = true;
                        if (SavingDataInObject()) {
                            let profileSaved = await parseModuleObjectForSave();
                            if (profileSaved) {
                                formData.syncPayItem = 0;
                                setFormData({...formData})
                                location.state.row = {...formData}
                                //Need to show the modal popup
                                setIsSelectable(editable);
                                setOpenModalForPayItem(true);
                            }else{
                                removingObject(formData.cicompensationId)
                            }
                        }
                    }
                }
            })
        }
        else {
            setIsSelectable(editable);
            setOpenModalForPayItem(true);
        }
    }

    async function attachComp(payItemRefNum) {
            let response = await props.attach_Pay_Item(formData.userId, SUBSCRIBER_SYNC_TYPE.COMPENSATION, formData.cicompensationId, payItemRefNum);
            
            if (response) {
                setFormData({ ...formData, ["payItemRefNum"]: payItemRefNum, syncPayItem: payItemRefNum === selected ? formData.syncPayItem : 0});
                changeLocationStateFormValues("payItemRefNum", payItemRefNum);
                changeLocationStateFormValues("syncPayItem", payItemRefNum === selected ? formData.syncPayItem : 0);
            }
        return response;
    }

    return (
        <>
            <ConfirmAlert confirmAlert={confirmAlert} setConfirmAlert={setConfirmAlert} />
            <Container fluid className="main-content-container p-0">
                <Form onSubmit={onSave}>
                    <Card small className=" w-100" style={{ borderRadius: 0 }}>
                        <Row className="w-100" style={{ marginLeft: '-4px' }}>
                            <Col lg="12" className="form-group m-1 p-1">
                                <Card small className="mb-0 w-100" style={{ borderRadius: 0 }}>
                                    <Row className="m-1">
                                        <Col lg="8" className="d-flex flex-row">
                                            {/*<h4 className="m-0">Placement - First Name Last Name</h4>*/}
                                        </Col>
                                        <Col lg="4" className="d-flex flex-row-reverse">
                                            <Button onClick={onCancel} className="my-2 py-2 mx-2" size='sm'
                                                theme="accent">Cancel</Button>

                                            <Button className="my-2 py-2 mx-2" size='sm'  disabled={disabledSave}
                                                theme="accent">Save</Button>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                    </Card>
                    <Card small className="mb-4 w-100 p-3" style={{ borderRadius: 0 }}>


                        <Card small className="mb-4 mt-5 w-100">
                            <h4 className="m-0 section-title idStyle">Ref# {formData.HSAId}</h4>
                            <ListGroup flush>
                                <ListGroupItem className="border-card p-3">

                                    <Row>

                                        <Col lg="3" className="form-group m-0 p-2">
                                            <label htmlFor="HSAProvider">HSA Provider{recordCRFields['hsainfos.HSAProvider'] && <CRBadge newValue={recordCRFields['hsainfos.HSAProvider'].newValue} />}</label>
                                            <span aria-hidden="true" className="required"> *</span>
                                            <FormInput
                                                required={true}
                                                id="HSAProvider"
                                                placeholder="Enter HSA Provider"
                                                onChange={onChange}
                                                name='HSAProvider'
                                                value={formData.HSAProvider}
                                            />
                                        </Col>

                                        <Col lg="3" className="form-group m-0 p-2">

                                            <label htmlFor="HSAStartDate">HSA Start Date{recordCRFields['hsainfos.HSAStartDate'] && <CRBadge newValue={recordCRFields['hsainfos.HSAStartDate'].newValue} />}</label>
                                            <span aria-hidden="true" className="required"> *</span>
                                            <DatePicker
                                                id='HSAStartDate'
                                                required={true}
                                                autoComplete='off'
                                                name='HSAStartDate'
                                                dateFormat='yyyy-MM-dd'
                                                selected={formData.HSAStartDate}
                                                onChange={(date) =>
                                                    onDateChange("HSAStartDate", date)
                                                }
                                                value={formData.HSAStartDate}
                                                placeholderText="YYYY-MM-DD"
                                            />
                                        </Col>
                                        <Col lg="3" className="form-group m-0 p-2">
                                            <label htmlFor="HSAEndDate">HSA End Date{recordCRFields['hsainfos.HSAEndDate'] && <CRBadge newValue={recordCRFields['hsainfos.HSAEndDate'].newValue} />}</label>
                                            <DatePicker
                                                id='HSAEndDate'
                                                autoComplete='off'
                                                name='HSAEndDate'
                                                dateFormat='yyyy-MM-dd'
                                                selected={formData.HSAEndDate}
                                                onChange={(date) =>
                                                    onDateChange("HSAEndDate", date)
                                                }
                                                value={formData.HSAEndDate}
                                                placeholderText="YYYY-MM-DD"
                                            />

                                        </Col>

                                        <Col lg="3" className="form-group m-0 p-2">
                                            <label htmlFor="HSACarryOver">HSA Carry Over{recordCRFields['hsainfos.HSACarryOver'] && <CRBadge newValue={recordCRFields['hsainfos.HSACarryOver'].newValue} />}</label>
                                            <span aria-hidden="true" className="required"> *</span>
                                            <FormSelect required={true} name='HSACarryOver' value={formData.HSACarryOver}
                                                onChange={onChange} className='d-block'>
                                                <option value=''>Select Carry Over</option>
                                                <option value='Yes'>Yes</option>
                                                <option value='No'>No</option>
                                            </FormSelect>
                                        </Col>

                                        <Col lg="3" className="form-group m-0 p-2">
                                            <label htmlFor="frequency">Frequency{recordCRFields['hsainfos.frequency'] && <CRBadge newValue={recordCRFields['hsainfos.frequency'].newValue} />}</label>
                                            <span aria-hidden="true" className="required"> *</span>
                                            <FormSelect required={true} className='d-block' name='frequency'
                                                value={formData.frequency} onChange={onChange}>
                                                <option value=''>Select Frequency</option>
                                                <option value='Weekly'>Weekly (52 Cycles)</option>
                                                <option value='Bi-weekly'>Bi-weekly (26 Cycles)</option>
                                                <option value='Semi-monthly'>Semi-monthly (24 Cycles)</option>
                                                <option value='Monthly'>Monthly (12 Cycles)</option>
                                            </FormSelect>
                                        </Col>

                                        <Col lg="3" className="form-group m-0 p-2">
                                            <label htmlFor="HSAContributionCurrency">HSA Contribution Currency{recordCRFields['hsainfos.HSAContributionCurrency'] && <CRBadge newValue={recordCRFields['hsainfos.HSAContributionCurrency'].newValue} />}</label>
                                            <span aria-hidden="true" className="required"> *</span>
                                            <FormSelect required={true} id='HSAContributionCurrency' name='HSAContributionCurrency'
                                                value={formData.HSAContributionCurrency} onChange={onChange}
                                                className='d-block'>
                                                <option value=''>Select HSA Contribution Currency</option>
                                                {currencyListOptions}
                                            </FormSelect>
                                        </Col>

                                        <Col lg="3" className="form-group m-0 p-2">
                                            <label htmlFor="waitingPeriod">HSA Waiting Period{recordCRFields['hsainfos.HSAWaitingPeriod'] && <CRBadge newValue={recordCRFields['hsainfos.HSAWaitingPeriod'].newValue} />}</label>
                                            <span aria-hidden="true" className="required"> *</span>
                                            <FormSelect required={true} className='d-block' name='HSAWaitingPeriod'
                                                value={formData.HSAWaitingPeriod}
                                                onChange={onChange}>
                                                <option value=''>Select HSA Waiting Period</option>
                                                {monthsList}
                                            </FormSelect>
                                            {/*<span className="subLabel" style={{right: "39px"}}>months</span>*/}
                                        </Col>

                                        <Col lg="3" className="form-group m-0 p-2">
                                            <label htmlFor="HSAWaitingPeriodUnit">HSA Waiting Period Unit{recordCRFields['hsainfos.HSAWaitingPeriodUnit'] && <CRBadge newValue={recordCRFields['hsainfos.HSAWaitingPeriodUnit'].newValue} />}</label>
                                            <span aria-hidden="true" className="required"> *</span>
                                            <FormSelect required={true} className='d-block' name='HSAWaitingPeriodUnit'
                                                value={formData.HSAWaitingPeriodUnit}
                                                onChange={onChange}>
                                                <option value=''>Select HSA Waiting Period Unit</option>
                                                <option value='Months'>Months</option>
                                                <option value='Weeks'>Weeks</option>

                                            </FormSelect>

                                        </Col>

                                        <Col lg="3" className="form-group m-0 p-2">
                                            <label>HR Pay Component{recordCRFields['hsainfos.HSAPayComponentId'] && <CRBadge newValue={recordCRFields['hsainfos.HSAPayComponentId'].newValue} />}</label>
                                            <FormSelect name='HSAPayComponentId' value={formData.HSAPayComponentId}
                                                onChange={onChange} className='d-block'>
                                                <option value='0'>Select HR Pay Component</option>
                                                {payComponentListOption}
                                            </FormSelect>
                                        </Col>

                                    {/*<Col lg="3" className="form-group m-0 p-2">
                                        <label htmlFor="HSAAmount">HSA Contribution Amount</label>
                                        <span aria-hidden="true" className="required">*</span>
                                        <FormInput
                                            required={true}
                                            id="HSAAmount"
                                            placeholder="0.00"
                                            className="align-input-amount-right"
                                            onChange={(e) => onMonetaryAmountChanged(e, 2)}
                                            name='HSAAmount'
                                            value={formData.ciCompensationCurrency + formData.HSAAmount}
                                        />
                                    </Col>*/}
                                     <StandardFormInput
                                        id="HSAAmount"
                                        name='HSAAmount'
                                        label={<>HSA Contribution Amount{recordCRFields['hsainfos.HSAAmount'] && <CRBadge newValue={recordCRFields['hsainfos.HSAAmount'].newValue} />}</>}
                                        standardFormat={STANDARD_FORMATS.COMMA_SEPERATED_NUMBER}
                                        dataMaxFracDigits={2}
                                        type="text"
                                        value={formData.HSAAmount}
                                        onChangeStandardInput={onChangeStandardInput}
                                        required
                                        placeholder="0.00"
                                        align='right'   
                                    />

                                    <Col lg="4" className="form-group m-0 p-2">
                                            <div className="form-group m-0 d-flex flex-row justify-content-left mb-2">
                                                <label className='col-lg-5 pl-0'> Sync Status </label>
                                                <label className={ Number(formData.syncPayItem) === 1 ? 'text-success col-lg-4' : 'text-danger col-lg-4'}> 
                                                    { Number(formData.syncPayItem) === 1 ? 'Synced' : 'Not Synced'} </label>
                                                <div className='col-lg-4'>
                                                    <Button onClick={() => syncPayItemWithUser()}>Sync</Button>
                                                </div>
                                            </div>
                                            <div className="form-group m-0 d-flex flex-row justify-content-left mb-2">
                                                <label className='pl-0 col-lg-4 pr-0'> Pay Item Reference </label>
                                                <label className="pl-0 primary-text font-weight-bold ml-1 col-lg-4 text-center" role="button" onClick={() => { 
                                                    if(formData.payItemRefNum > 0) history.push({
                                                        pathname: `/sub-add-edit-pay-item/${formData.payItemRefNum}`,
                                                        state: {
                                                            refNum: formData.payItemRefNum,
                                                            role: location.state.role,
                                                            formData: location.state.formData,
                                                            formDataRef: location.state.formDataRef,
                                                            sectionformDataRef: location.state.sectionformDataRef
                                                        },
                                                    });
                                                    }} >
                                                    { formData.payItemRefNum > 0 && formData.payItemRefNum }
                                                </label>
                                                <div className='col-lg-5 pl-0 '>
                                                    <Button className="mr-2 mt-1" onClick={() => openPayItemReference(true)}>
                                                        Find Pay Item
                                                    </Button>
                                                </div>
                                            </div>
                                            <PayTypeComponentModal openModal={openModalForPayItem}
                                                attachPayItem={attachComp}
                                                openModalFunc={toggleModal} userName={userNameForModal}
                                                setSelected={setSelected} existingSelection={formData.payItemRefNum ?? 0}
                                                isSelectable={isSelectable}>
                                            </PayTypeComponentModal>
                                        </Col>
                                        {/* <Col lg="3" className="form-group m-0 p-2"></Col> */}
                                        <Col lg="2" className="form-group m-0 p-2"></Col>

                                        <Col lg="3" className="form-group m-0 p-2">
                                            <label htmlFor="HSAWaitingPeriodUnit">HSA Markup Type{recordCRFields['hsainfos.HSAMarkup'] && <CRBadge newValue={recordCRFields['hsainfos.HSAMarkup'].newValue} />}</label>
                                            <span aria-hidden="true" className="required"> *</span>
                                            <FormSelect required={true} name='HSAMarkup' value={formData.HSAMarkup}
                                                onChange={onChange} className='d-block'>
                                                <option value=''>Select HSA Markup Type</option>
                                                <option value='%'>%</option>
                                                < option value='Flat'>Flat</option>
                                            </FormSelect>
                                        </Col>
                                        <InputBox required={true} placeholder="0.00" label={<>HSA Markup Amount{recordCRFields['hsainfos.HSAMarkupAmount'] && <CRBadge newValue={recordCRFields['hsainfos.HSAMarkupAmount'].newValue} />}</>} id='HSAMarkupAmount' name='HSAMarkupAmount'
                                            value={formData.HSAMarkupAmount}
                                            align={formData.HSAMarkup === '%' ? 'left' : 'right'}
                                            onChange={(e) => onMonetaryAmountChanged(e, 2)} />
                                    </Row>

                                    <Row>
                                        <Col>
                                            <label htmlFor="notes">Notes{recordCRFields['hsainfos.notes'] && <CRBadge newValue={recordCRFields['hsainfos.notes'].newValue} />}</label>
                                            <textarea placeholder='Enter Your Notes' maxLength="100" className="form-control" value={formData.notes} rows="3" id="notes" name="notes" onChange={(e) => {

                                                if (formData.notes.length >= 99) {

                                                    props.setAlert("Notes can not exceed more than 100 charaters.", "danger")
                                                }
                                                onChange(e)
                                            }}>
                                                {formData.notes}
                                            </textarea>
                                            <span>Maximum {notesCharacters} characters.</span>
                                        </Col>
                                    </Row>
                                </ListGroupItem>
                            </ListGroup>
                        </Card>
                    </Card>
                </Form>
            </Container>
        </>
    );
}

HSAForm.propTypes = {
    userProfile: PropTypes.object.isRequired,
    get_user_profile: PropTypes.func.isRequired,
    user: PropTypes.object,
    workerTypes: PropTypes.array.isRequired,
    dealTypes: PropTypes.array.isRequired,
    currencyList: PropTypes.array.isRequired,
    setAlert: PropTypes.func.isRequired,
    success: PropTypes.any,
    reset: PropTypes.func.isRequired,
    payComponentList: PropTypes.array.isRequired,

}

const mapStateToProps = (state) => {

    return {
        userProfile: state.user.userProfile,
        isSaveUserProfile: state.user.isSaveUserProfile,
        user: state.user.user,
        workerTypes: state.user.workerTypes,
        dealTypes: state.user.dealTypes,
        currencyList: state.user.currencyList,
        message: state.user.message,
        success: state.user.success,
        alerts: state.alert,
        moduleName: state.user.moduleName,
        payComponentList: state.user.payComponentList,
        clientInformation: state.user.clientInformation,
    }
}
export default connect(mapStateToProps, {

    get_worker_types,
    get_user_profile,
    clear_user_profile,
    get_subscriber_list,
    get_hr_Consultant,
    sub_get_currency_list,
    get_country_list,
    get_compensation_types,
    get_region_list,
    get_deal_types_types,
    get_client_list,
    get_pay_component_list,
    setAlert,
    reset,
    save_user_profile,
    update_isSave_user_profile,
    get_pay_item_list,
    sync_pay_items,
    attach_Pay_Item,
    get_client_information,
})(HSAForm);